module.exports = ".highcharts-container {\n  margin: 0 auto; }\n\n.header-title-hover:hover {\n  cursor: pointer;\n  text-decoration: underline; }\n"